import { defineComponent as _defineComponent } from 'vue'
import { useSalesBotStore } from '@/store/modules/salesBot'
import { computed } from 'vue'
import { SalesBotStep } from '@/models/SalesBotStep'
import { SalesBotStepKey } from '@/utils/enum'
import SalesBotToBookingButton from '@/components/SalesBotToBookingButton.vue'
import { useDisplay } from '@/composables/useDisplay'
import { useAuth0 } from "@/composables/useAuth0";
import { useGoogleAnalytics, Event } from "@/composables/useGoogleAnalytics";
import auth from "@/store/modules/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesBotForm',
  setup(__props) {

const salesBotStore = useSalesBotStore()
const { smAndDown } = useDisplay()

// Computed properties
const isCustomerDetailsStep = computed(() => salesBotStore?.currentStep?.key === SalesBotStepKey.CustomerDetails)
const isAuthenticationStep = computed(() => salesBotStore?.currentStep?.key === SalesBotStepKey.Authentication)
const accordionSteps = computed<SalesBotStep[]>(() => salesBotStore?.accordionSteps ?? [])
const visibleAccordionSteps = computed(() => accordionSteps.value.filter(step => step.isVisible()))
const areAllStepsValid = computed(() => accordionSteps.value.every(step => step.isValid))
const accordionContainerPadding = computed(() => {
  if (!smAndDown.value) {
    return '0px'
  }
  return salesBotStore?.showProceedToBooking ? '240px' : '180px'
})
const isAuthenticated = computed(() => !!auth.isTokenSet)

// Event handlers
const onCustomerUpdate = () => salesBotStore?.currentStep?.next()
const onPopupUpdate = () => {
  if (isAuthenticated.value) {
    salesBotStore?.currentStep?.next()
  }
}

const onValidate = (stepKey: SalesBotStepKey, isValid: boolean) => {
  salesBotStore.setStepValid(stepKey, isValid)
}

const goToNext = (validate: () => boolean, step: SalesBotStep) => {
  const isValid = validate()
  step.isValid = isValid
  if (!isValid) {
    return
  }

  switch (step.key) {
    case SalesBotStepKey.Itinerary:
      trackStepSubmission(Event.Itinerary)
      break
    case SalesBotStepKey.TripDetails:
      trackStepSubmission(Event.TripDetails)
      break
    case SalesBotStepKey.Vehicles:
      trackStepSubmission(Event.VehicleType)
      break
    default:
  }

  step.next()
}

function handleBackButtonClick(e: MouseEvent) {
  e.preventDefault();
  const currentStepKey = salesBotStore.currentStep?.key
  if ([SalesBotStepKey.CustomerDetails, SalesBotStepKey.Authentication].includes(currentStepKey)) {
    salesBotStore.setCurrentStep(SalesBotStepKey.TripDetails)
  } else {
    salesBotStore.setCurrentStep(SalesBotStepKey.TripType)
  }
}

// GA4 TRACKING
const analytics = useGoogleAnalytics()
const auth0 = useAuth0()

function trackStepSubmission(event: Event): void {
  const isLoggedIn = !!auth.isTokenSet && !!auth.userId
  const hasBookedBefore = auth?.customer?.convertedQuoteCount > 0

  analytics.trackEvent(event, {
    isAuth0: auth0.isInitialized,
    hasBookedBefore,
    isLoggedIn,
  })
}

return { __sfc: true,salesBotStore, smAndDown, isCustomerDetailsStep, isAuthenticationStep, accordionSteps, visibleAccordionSteps, areAllStepsValid, accordionContainerPadding, isAuthenticated, onCustomerUpdate, onPopupUpdate, onValidate, goToNext, handleBackButtonClick, analytics, auth0, trackStepSubmission, SalesBotStepKey, SalesBotToBookingButton }
}

})